<template>
  <div class="student-deed-atom">
    <div class="main">
      <div class="user-info">
        <div class="l-box">
          <div class="nickname">{{ data.nickname }}</div>
          <div class="desc">{{ data.desc }}</div>
        </div>
        <div class="camp-num">{{ data.camp_num + 1 }}期学员</div>
      </div>
      <div class="title">{{ data.title }}</div>
      <div class="article" v-show="showMore" v-cloak>
        <deed-item-article :content="articleContent"></deed-item-article>
      </div>
      <div class="operate-btn" :class="[showMore ? 'on' : 'off']">
        <span class="text" @click.stop="showMore = !showMore">{{ showMore ? '收起' : '看看Ta的事迹'}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import deedItemArticle from '@/components/deedItemArticle/deedItemArticle.vue';
import request from '@/plugins/axios';

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    deedItemArticle,
  },
  data() {
    return {
      showMore: false,
      articleContent: '',
    };
  },
  mounted() {
    // 事迹
    let articleUrl = process.env.NODE_ENV !== 'development'
      ? this.data.content
      : this.data.content.replace('http://talcdn.jhkong.com', '');

    if (window.location.protocol === 'https:') {
      articleUrl = articleUrl.replace('http:', 'https:');
    }

    request({
      method: 'get',
      url: articleUrl,
      withCredentials: false
    }).then((articleContent) => {
      this.articleContent = articleContent;
    });
  },
};
</script>

<style lang="stylus" scoped>
@import './../../common/stylus/variable.styl';
@import './../../common/stylus/mixin.styl';
.student-deed-atom {
  overflow hidden
  position relative
  width 100%
  padding 12px 16px
  background: #fff;
}
.main {
  width 100%
  // padding 0 16px
  background: #F6F7FA;
  border-radius: 4px;
  .user-info {
    position relative
    display flex
    align-items center
    justify-content space-between
    margin-bottom 15px
    padding 0 16px
    // border-bottom 1px solid #E7E7E7
    &::after {
      content ''
      display block
      position absolute
      bottom 0
      left 0
      right 0
      width calc(100% - 32px)
      height 1px
      margin auto
      background #E7E7E7
    }
    .l-box {
      flex 1
      overflow hidden
      .nickname {
        padding-top: 16px;
        font-size: 16px;
        font-weight: 500;
        color: $color-text;
        line-height: 24px;
        no-wrap()
      }
      .desc {
        margin-bottom 12px
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        line-height: 22px;
        no-wrap()
      }
    }
    .camp-num {
      margin-top 4px
      padding 6px 9px
      border-radius: 2px;
      border: 1px solid #DADADA;
      font-size: 12px;
      font-weight: 400;
      color: #999999;
      line-height: 12px;
    }
  }
  .title {
    padding 0 16px
    font-size: 18px;
    font-weight: 500;
    color: #191919;
    line-height: 24px;
  }
  .operate-btn {
    text-align center
    .text {
      display inline-flex
      align-items center
      justify-content center
      padding 22px 44px 18px
      font-size: 12px;
      font-weight: 400;
      color: #FF9645;
      line-height: 16px;
      &::after {
        content ''
        display inline-block
        width 12px
        height 12px
        margin-left 2px
      }
    }
    &.off {
      .text::after {
        background url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAHlBMVEUAAAD/qlX/mUT/kET/lkX/lkX/l0X/lkX/lkX/lkXBMk9RAAAACXRSTlMAAw8ewMjS2t1lK8PQAAAASUlEQVQY02NgGBDAmKIAopjcBECcyiAQR3U6iMNgMRUoxRTZDFbH3AmUUp1hANEFlIJJgKXgEiApuARICiHBwGBejGyxAHU8AAAxXA1agMm2HAAAAABJRU5ErkJggg==') center no-repeat
        background-size cover
      }
    }
    &.on {
      .text::after {
        background url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAHlBMVEUAAAD/qlX/mUT/kET/lkX/lkX/l0X/lkX/lkX/lkXBMk9RAAAACXRSTlMAAw8ewMjS2t1lK8PQAAAASElEQVQY02NgoApgFEDimBcj2MydMwzgHIupkc0IiSBVuJTFVAUmmBRQgoEBJgWUYGCASjFWBoEo1ekguxhTFEAcJjcBhgEBABJTDVrfILerAAAAAElFTkSuQmCC') center no-repeat
        background-size cover
      }
    }
  }
}
</style>
